// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "label[data-v-6beb8f67]{font-size:1rem;line-height:1.5rem;font-weight:700;--tw-text-opacity:1;color:rgb(57 7 63 / var(--tw-text-opacity))}@media (min-width: 1536px){label[data-v-6beb8f67]{font-size:1.125rem;line-height:1.75rem}}.input-text[data-v-6beb8f67]{border:1px solid #d6d1d8;border-radius:4px;padding:18px 20px;margin-top:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
